import useCulture from './useCulture';

export default () => {
    const { language } = useCulture();
    return language;
};
